import React from "react";

import { quemConduz } from "../../../utils/copy";
import manuRetrato from "../../../assets/images/ConversasTerapeuticas/queméManu.jpg";

/* Quem conduz — bloco próprio (doc jul/2026). Antes a bio existia em copy.ts
   sem chegar à tela; a seção "o que é" carregava só o posicionamento. */
export function QuemConduz() {
  return (
    <section id="quem-conduz" data-bg="#f0eadb" className="poster-section conductor-section">
      <div className="conductor-copy">
        <p className="conductor-kicker">03 · {quemConduz.kicker}</p>
        <h2 data-motion="title" className="type-display conductor-title">
          Manuela<br className="wide-only" /> Xavier
        </h2>
        <div data-motion="lead" className="conductor-bio">
          {quemConduz.bio.map((paragrafo) => (
            <p key={paragrafo.slice(0, 24)}>{paragrafo}</p>
          ))}
        </div>
        <div data-motion="gesture" aria-hidden="true" className="conductor-rule" />
      </div>
      <figure data-motion="media" className="conductor-photo">
        <img
          src={manuRetrato}
          alt="Retrato de Manuela Xavier usando blazer preto"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </figure>
    </section>
  );
}
